import { AxiosResponse, AxiosHeaders } from 'axios';
import ApiService from './api';
import {
  School,
  NewSchool,
  SchoolFileUpdate,
  TableSchoolFile,
  SchoolFileRemove,
  NewSchoolUpdate,
  UpdateSchoolYoutubeLinks
} from 'shared/types';

export const downloadAllSchoolLinkedHeadsetsReports = async (): Promise<void> => {
  try {
    const response = await ApiService.get<Blob>(`school/export-school-linked-headesets-report`);
    console.log(response)
    const contentDisposition = response.headers['content-disposition'];

    const matches = /filename="(.+)"/.exec(contentDisposition);
    const filename =
      matches && matches[1] ? matches[1] : `superadmin_linked_headsets_reports_${Date.now()}.csv`;

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Error downloading the CSV file:', error);
    throw error;
  }
};

export const getSchools = async (
  page: number,
  limit: number,
  orderBy: { orderBy?: string },
  search?: string
): Promise<AxiosResponse<School[]>> =>
  await ApiService.get<School[]>('school', { page, limit, ...orderBy, search });

export const getSchoolsList = async (
  page: number,
  limit: number,
  orderBy: { orderBy?: string },
  search?: string
): Promise<AxiosResponse<School[]>> =>
  await ApiService.get<School[]>('school/list', { page, limit, ...orderBy, search });

export const getSchoolById = async (id: string): Promise<AxiosResponse<School>> =>
  await ApiService.get<School>(`school/${id}`);

export const deleteSchool = async (id: string): Promise<AxiosResponse<void>> =>
  await ApiService.delete<void>(`school?id=${id}`);

export const addSchool = async (newSchool: NewSchool): Promise<AxiosResponse<School>> =>
  await ApiService.post<NewSchool, School>('school', newSchool);

export const updateSchool = async (
  schoolId: string,
  newSchool: NewSchoolUpdate
): Promise<AxiosResponse<void>> =>
  await ApiService.patch<NewSchoolUpdate, void>(`school/${schoolId}`, newSchool);

export const addSchoolLink = async (
  schoolId: string,
  body: UpdateSchoolYoutubeLinks
): Promise<AxiosResponse<void>> =>
    await ApiService.post<UpdateSchoolYoutubeLinks, void>(`school/link/${schoolId}`, body);

export const deleteSchoolLink = async (
  schoolId: string,
  body: UpdateSchoolYoutubeLinks
): Promise<AxiosResponse<void>> =>
    await ApiService.delete(`school/link/${schoolId}`, body);

export const getSchoolFiles = async (
  schoolId: string
): Promise<AxiosResponse<TableSchoolFile[]>> => {
  return await ApiService.get<TableSchoolFile[]>(`school/files/${schoolId}`);
};

export const uploadSchoolFile = async (
  schoolId: string,
  file: File
): Promise<AxiosResponse<void>> => {
  const bodyFormData = new FormData();
  bodyFormData.append('media', file);
  return await ApiService.post<FormData, void>(`school/files/${schoolId}`, bodyFormData, {
    headers: new AxiosHeaders({ 'Content-Type': 'multipart/form-data' })
  });
};

export const renameSchoolFile = async (
  schoolId: string,
  oldFileKey: string,
  newFileKey: string
): Promise<AxiosResponse<void>> => {
  return await ApiService.patch<SchoolFileUpdate, void>(`school/files/${schoolId}`, {
    oldFileKey,
    newFileKey
  });
};

export const removeSchoolFile = async (
  schoolId: string,
  fileKey: string
): Promise<AxiosResponse<void>> => {
  return await ApiService.delete<SchoolFileRemove, AxiosResponse<void>>(
    `school/files/${schoolId}`,
    {
      fileKey
    }
  );
};
